/** Marketplace peso formatting — whole pesos with thousands separators ("₱1,253"). */
export function peso(value: string | number, opts?: { decimals?: boolean }): string {
  const num = typeof value === 'string' ? Number(value) : value;
  if (!Number.isFinite(num)) return '₱0';
  return (
    '₱' +
    num.toLocaleString('en-PH', {
      minimumFractionDigits: opts?.decimals ? 2 : 0,
      maximumFractionDigits: opts?.decimals ? 2 : 0,
    })
  );
}

/** The original "was" price implied by an effective price + discount %. */
export function wasFromOff(price: number, off: number): number {
  if (off <= 0) return price;
  return Math.round(price / (1 - off / 100));
}
